__turbopack_context__.v({
  "btnRequest": "styles-module-scss-module__0rmpmW__btnRequest",
  "code": "styles-module-scss-module__0rmpmW__code",
  "content": "styles-module-scss-module__0rmpmW__content",
  "page": "styles-module-scss-module__0rmpmW__page",
  "root": "styles-module-scss-module__0rmpmW__root",
  "scratchCardContainer": "styles-module-scss-module__0rmpmW__scratchCardContainer",
  "scratchContainer": "styles-module-scss-module__0rmpmW__scratchContainer",
  "scratchingText": "styles-module-scss-module__0rmpmW__scratchingText",
  "title": "styles-module-scss-module__0rmpmW__title",
});
